/**
 * Lightbox
 * By Osvaldas Valutis, www.osvaldas.info
 * Available for use under the MIT License
 */
import $ from 'jquery'
import './lightbox_src.js'


var opt = {
	activity       : true,
	arrows         : true,
	button         : true,
	caption        : true,
	navigation     : true,
	overlay        : true,
	quitOnDocClick : false,
	selector       : '.lightbox'
};

$('.slider_grid .lightbox').imageLightbox(opt);
$('.single_image .lightbox').imageLightbox(opt)


// WEBPACK FOOTER //
// ./src/themes/pac/js/lightbox.js